import { LayoutHeader } from "@/Header";
import { ValidateSelectList } from "@/SelectList";
import { createFileRoute } from "@tanstack/react-router";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import ReservationClass from "@/customer/reservation/ReservationClass";
import ReservationDaycare from "@/customer/reservation/ReservationDaycare";
import ReservationHotel from "@/customer/reservation/ReservationHotel";
import ReservationBeauty from "@/customer/reservation/ReservationBeauty";
import { ValidateControllerSelect } from "@/ControllerSelect";
import { useProductList } from "~/services/reservation";
import { useUserReserveCompanyList } from "~/services/customer/reservation";
import { usePet } from "^/common/usePet";

interface ReservationParams {
  companySeq?: string | undefined;
  companyName?: string | undefined;
  date?: string | undefined;
}

export const Route = createFileRoute("/customer/layout/calendar-reservation")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): ReservationParams => {
    return {
      companySeq: search.companySeq as string | undefined,
      companyName: search.companyName as string | undefined,
      date: search.date as string | undefined,
    };
  },
});
interface OwnerOptions {
  value: string;
  label: string;
}

interface InformSendState {
  storeName: OwnerOptions;
  storeType: string;
  content: string;
  weekly: boolean;
  day: string;
  services: string;
  animal: string;
  agree: boolean;
}

function RouteComponent() {
  const {
    control,
    formState: { errors },
    watch,
    setValue,
  } = useForm<InformSendState>({
    defaultValues: {
      storeName: { value: "", label: "" },
      storeType: "",
      content: "",
      weekly: false,
      day: "",
      services: "",
      animal: "",
      agree: false,
    },
    mode: "onChange",
  });
  const { companySeq, companyName, date } = Route.useSearch();
  console.log(date);
  const [storeType, setStoreType] = useState<string>("");
  const [selectedCompanySeq, setSelectedCompanySeq] = useState<string>("");

  // 디버깅을 위한 로그
  console.log("selectedCompanySeq:", selectedCompanySeq);
  console.log(
    "enabled condition:",
    selectedCompanySeq !== "" && selectedCompanySeq !== "0"
  );

  const { data: productTypeList } = useProductList(
    parseInt(selectedCompanySeq || "0"),
    selectedCompanySeq !== "" && selectedCompanySeq !== "0"
  );

  console.log("productTypeList:", productTypeList);
  const { usePetList } = usePet();
  const { data: petList } = usePetList();

  // 업체 목록 조회
  const { data: companyListData } = useUserReserveCompanyList();
  const [companyList, setCompanyList] = useState<
    { value: string; label: string }[]
  >([]);

  useEffect(() => {
    if (companyListData?.data && companyListData?.data.length > 0) {
      setCompanyList(
        companyListData?.data?.map((company) => ({
          value: company.companySeq.toString(),
          label: company.companyName,
        })) || []
      );
    }
  }, [companyListData]);

  // URL 파라미터로 전달된 값이 있으면 폼에 설정
  useEffect(() => {
    if (companySeq && companyName) {
      setValue("storeName", { value: companySeq, label: companyName });
      setSelectedCompanySeq(companySeq);
    }
  }, [companySeq, companyName, setValue]);

  // 업체 선택 시 selectedCompanySeq 업데이트
  useEffect(() => {
    const selectedValue = watch("storeName.value");
    console.log("watch storeName.value:", selectedValue);
    if (selectedValue) {
      setSelectedCompanySeq(selectedValue);
    } else {
      setSelectedCompanySeq("");
    }
  }, [watch("storeName.value")]);

  useEffect(() => {
    setStoreType(watch("storeType"));
  }, [watch("storeType")]);

  return (
    <>
      <LayoutHeader title={"예약"} hasBackBtn hasFootPrint={false} />
      {/* 수신자 */}
      <div className="flex flex-col flex-auto">
        <div className="flex-col flex-auto gap-1 px-5 pt-5 bg-[#F5F5F5] grid grid-cols-1">
          <div className="">
            <Controller
              name="storeName"
              control={control}
              rules={{ required: "필수 선택입니다." }}
              render={({ field }) => (
                <ValidateSelectList
                  onChange={(value) => {
                    console.log("ValidateSelectList onChange:", value);
                    // React Hook Form의 field.onChange 호출
                    field.onChange(value);
                    // 직접 selectedCompanySeq 업데이트
                    if (value && value.value) {
                      setSelectedCompanySeq(value.value);
                    } else {
                      setSelectedCompanySeq("");
                    }
                  }}
                  placeholder="위탁사업자 이름"
                  value={field.value && field.value.value ? field.value : null}
                  options={companyList}
                />
              )}
            />
            {watch("storeName.value") && (
              <div className="mt-4">
                <Controller
                  name="storeType"
                  control={control}
                  rules={{ required: "필수 선택입니다." }}
                  render={({ field }) => (
                    <ValidateControllerSelect
                      value={
                        field.value && field.value !== ""
                          ? field.value.split(",")
                          : []
                      }
                      onChange={(value) => {
                        field.onChange(value.join(","));
                      }}
                      label="예약 유형 선택"
                      required={true}
                      max={1}
                      errorMessage={errors?.storeType?.message}
                      options={
                        productTypeList
                          ? productTypeList
                              ?.filter((item) => item.active)
                              .map((item) => ({
                                label: item.productName,
                                value: item.cdProvideType,
                              }))
                          : []
                      }
                    />
                  )}
                />
              </div>
            )}
            {storeType === "PRODUCT_TYPE_KINDERGARTEN" && (
              <ReservationClass
                storeName={watch("storeName.label")}
                storeType={storeType}
                storeData={watch("storeName")}
                petList={petList}
                date={date || ""}
              />
            )}
            {storeType === "PRODUCT_TYPE_DAYCARE" && (
              <ReservationDaycare
                storeName={watch("storeName.label")}
                storeType={storeType}
                storeData={watch("storeName")}
                petList={petList}
                date={date || ""}
              />
            )}
            {storeType === "PRODUCT_TYPE_HOTEL" && (
              <ReservationHotel
                storeName={watch("storeName.label")}
                storeType={storeType}
                storeData={watch("storeName")}
                petList={petList}
                date={date || ""}
              />
            )}
            {storeType === "PRODUCT_TYPE_GROOMING" && (
              <ReservationBeauty
                storeName={watch("storeName.label")}
                storeType={storeType}
                storeData={watch("storeName")}
                petList={petList}
                date={date || ""}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
